import React, { useState } from "react";
import { toast } from "react-toastify";

import { useSiteFormik } from "../../../../shared/Forms/SiteForm/lib/useSiteFormik";
import { useCustomerContext } from "../../../../../lib/context/Customer/CustomerContext";
import { useWorkplaceRequests } from "../../../../../api/graphql/useWorkplaceRequests";

import { WorkplaceModalProps } from "../AddWorkplaceModal";

import { SiteForm } from "../../../../shared/Forms/SiteForm/SiteForm";
import ModalSidebar from "../../../../Modals/ModalSidebar/ModalSidebar";
import { AddSiteVariables } from "../../../../../api/graphql/sites/sites";

export const AddSiteModal = (props: WorkplaceModalProps) => {
  const { isOpen, toggle, parentId, parentType } = props;

  const { addSite } = useWorkplaceRequests();
  const { retrieveTenant } = useCustomerContext();
  const [loading, setLoading] = useState<boolean>(false);

  const formik = useSiteFormik({
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const { id, tenantId } = await retrieveTenant();

        const variables: AddSiteVariables = {
          id: parentId || id,
          tenantId,
          name: values.name,
          tags: values.tags,
          description: values.description,
        };

        await addSite(variables, parentType);

        toggle();
        toast.success("Site added successfully!");
      } catch (error: any) {
        toast.error(
          error?.message ||
            "Site couldn't be added, please reload and try again!"
        );
        setLoading(false);
        console.error(error.message);
      }
    },
  });

  return (
    <ModalSidebar
      isOpen={isOpen}
      loading={loading}
      onToggle={toggle}
      title="Add new Site"
      onSubmit={formik.handleSubmit}
    >
      <SiteForm formik={formik} informationBoxDirection="left" />
    </ModalSidebar>
  );
};
